export default function InviteUserScreen() {
  return null;
}